/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_Filter_PublishedInputs */

const en_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const es_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicados`)
};

const fr_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publiées`)
};

const de_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

const ja_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中`)
};

const zh_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布`)
};

const ar_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشور`)
};

const id_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterbitkan`)
};

const it_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicati`)
};

const ru_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликованные`)
};

const pt_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicados`)
};

const ko_seller_listings_filter_published = /** @type {(inputs: Seller_Listings_Filter_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게시됨`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Seller_Listings_Filter_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_filter_published = /** @type {((inputs?: Seller_Listings_Filter_PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_Filter_PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_filter_published(inputs)
	if (locale === "es") return es_seller_listings_filter_published(inputs)
	if (locale === "fr") return fr_seller_listings_filter_published(inputs)
	if (locale === "de") return de_seller_listings_filter_published(inputs)
	if (locale === "ja") return ja_seller_listings_filter_published(inputs)
	if (locale === "zh") return zh_seller_listings_filter_published(inputs)
	if (locale === "ar") return ar_seller_listings_filter_published(inputs)
	if (locale === "id") return id_seller_listings_filter_published(inputs)
	if (locale === "it") return it_seller_listings_filter_published(inputs)
	if (locale === "ru") return ru_seller_listings_filter_published(inputs)
	if (locale === "pt") return pt_seller_listings_filter_published(inputs)
	return ko_seller_listings_filter_published(inputs)
});